<template> 
       <!-- web user menu -->
        <div style="background:white" class="dropdown-menu vendor-menu mt-3" aria-labelledby="vendor-menu-btn">
            <!--
            <a @click="openPage('Mojerezervacije')" class="dropdown-item" href="/vendor#Mojerezervacije"><span class="fas fa-calendar fa-fw"></span>Moje rezervacije</a>
            -->
            <a @click="openPage('Omiljenisalon')" class="dropdown-item" href="/user#Omiljenisalon"><span class="fas fa-heart fa-fw"></span>Omiljeni saloni</a>
            <a @click="openPage('Mojikomentari')" class="dropdown-item" href="/user#Mojikomentari"><span class="far fa-comments fa-fw"></span>Moji komentari</a>
            <!-- @click="openPage('nadzorna')" <a class="dropdown-item" href="/user#userpromo"><span class="fas fa-tags fa-fw"></span>Promo bodovi</a> -->
            <a @click="openPage('postavke')" class="dropdown-item" href="/user#postavke" ><span class="fas fa-cog fa-fw"></span>Postavke profila</a>
            <div class="dropdown-divider"></div>
            <a @click="logoutNow($event)" class="dropdown-item" href="/user#"><span class="fas fa-sign-out-alt fa-fw"></span>Odjavi se</a>
        </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name:'authDropDown',
    computed:{
        ...mapState({
            user:(state)=>state.user
        })
    },
    methods:{
        logoutNow(e){
            e.preventDefault(); 
            this.$store.commit('logout');
            window.location.href='/';
        },
        openPage(page){
            setTimeout(()=>{
                document.getElementById(page).click();
            },500);
        }
    },
    mounted(){ 
    }
}
</script>